import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import CustomizedGrid from '../../../../components/base/Grid/CustomizedGrid';
import Pagination from '../../../../components/base/Pagination/Pagination';
import { intlShape } from '../../../../components/base/IntlProviderWrapper';
import { Button, Icons } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  getFilterData, getPaginationOpts, responseLogWithNotification, useUpdatePeriod,
} from '../../../../utils/utils';
import { VIOLATIONS_MODULE } from '../../../../configs/moduleNames';
import { getSystemData } from '../../../System/reducer';
import FilterRow from '../../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../../components/fields/TextInput/TextInput';
import { getViolationData } from '../../../Violations/reducer';
import { loadViolationsList } from '../../../Violations/actions';
import { addGlobalPopUpWrapper } from '../../../InformationScreenWrapper/actions';
import { POPUP_LIST_NAME } from '../../../../configs';
import getDefaultSort from '../../../../utils/getDefaultSort';
import { violationColumns } from '../DriverLogColumns';
import FilterModal from '../../../FilterTemplate/components/FilterModal';
import { PAGE_TYPE } from '../../../FilterTemplate/components/filter-settings';
import TimerLoader from '../../../../components/base/Loader/TimerLoader';
import TextSearchInput from '../../../../components/fields/TextInput/TextSearchInput';

export function ViolationBox(props) {
  const { driver_id, onClose = () => {} } = props;
  const dispatch = useDispatch();
  const filterName = 'violation-filter-details-by-driver';
  const {
    violationList = [],
    loadingViolationList,
    violationListMeta,
  } = useSelector(getViolationData);
  const store = useStore();
  const [isOpenFilter, setOpenFilter] = useState(false);
  const {
    formatMessage,
  } = intlShape;

  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[VIOLATIONS_MODULE].transportListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: { driver_id, ...getValues() },
      sort,
    };
    const p1 = dispatch(loadViolationsList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const {
    getValues, control, watch, setValue, reset,
  } = useForm({ defaultValues: getFilterData('visit-filter', {}) });
  const { updatePeriod } = useSelector(getSystemData);
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  const moreFormatter = (_, item) => (
    <Icons customIcon icon="more-vert" className="more-vert" />
  );

  useEffect(() => {
    const subscription = watch(values => {
      localStorage.setItem(filterName, JSON.stringify(values));
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const [sort, setSort] = useState(getDefaultSort(violationColumns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);
  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    return classes.join(' ');
  };

  return (
    <div className="dlc-body flex-column">
      <TimerLoader loading={loadingViolationList} />
      <div className="dlc-title">
        <Icons width={24} height={24} customIcon icon="arrow-return" onClick={onClose} />
        <div className="f3">{formatMessage({ id: 'driver.card.menu.violation' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextSearchInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            placeholder="Поиск по нарушению"
          />
          <Button
            variant="second"
            className=""
            onClick={() => {
              setOpenFilter(true);
            }}
          >
            <Icons customIcon className="file-download" width={24} height={24} icon="filter" />
          </Button>
          {isOpenFilter
            ? (
              <FilterModal
                control={control}
                onClose={() => setOpenFilter(false)}
                getValues={getValues}
                reset={reset}
                defaultValues={{}}
                page={PAGE_TYPE.VIOLATIONS}
              />
            )
            : null}
        </FilterRow>
      </div>
      <div className="grid-wrapper frame">
        <div className="custom-scroll-theme sticky-table-wrapper custom">
          <CustomizedGrid
            data={violationList}
            columns={violationColumns}
            onDoubleClickByRow={item => {
              dispatch((addGlobalPopUpWrapper({ window: POPUP_LIST_NAME.VIOLATION_DETAIL, id: item.id })));
            }}
            rowClassFormatter={rowClassFormatter}
            additionalColumns={[]}
            changeSort={changeSort}
            sort={sort}
            name="violation-list"
            settingsFormatter={moreFormatter}
          />
        </div>
        <Pagination meta={violationListMeta} list={violationList} handleChangeMeta={loadData} />
      </div>
    </div>
  );
}
